import { makeStyles } from "@material-ui/styles";

const useStyle = makeStyles((theme) => ({
  root: {
    marginBottom: 24,
    padding: 24,
    border: `1px solid ${theme.props.border}`,
    borderRadius: 10,
    backgroundColor: theme.props.backgroundLevel2,
  },
  title: {
    gap: 16,
    marginBottom: 24,
    paddingBottom: 24,
    borderBottom: `1px solid ${theme.props.border}`,
  },
  description: {
    color: theme.palette.text.secondary,
    lineHeight: 1.5,
  },
  status: {
    flexShrink: 0,
    fontWeight: 600,
    borderWidth: 1,
    borderStyle: "solid",
    marginLeft: 8,
  },
  statusActive: {
    color: theme.props.success,
    borderColor: `${theme.props.success}66`,
    backgroundColor: `${theme.props.success}18`,
  },
  statusPending: {
    color: theme.props.warning,
    borderColor: `${theme.props.warning}66`,
    backgroundColor: `${theme.props.warning}18`,
  },
  statusError: {
    color: theme.props.error.main,
    borderColor: `${theme.props.error.main}66`,
    backgroundColor: `${theme.props.error.main}12`,
  },
  statusNeutral: {
    color: theme.palette.text.secondary,
    borderColor: theme.props.border,
    backgroundColor: theme.props.backgroundSecondary,
  },
  label: {
    margin: 0,
    color: theme.palette.text.secondary,
    fontSize: 11,
    fontWeight: 700,
    letterSpacing: "0.06em",
    lineHeight: 1.3,
    textTransform: "uppercase",
  },
  value: {
    margin: "5px 0 0",
    color: theme.palette.text.primary,
    fontWeight: 600,
    overflowWrap: "anywhere",
  },
  scope: {
    display: "inline-flex",
    padding: "3px 8px",
    borderRadius: 4,
    color: theme.palette.primary.main,
    backgroundColor: theme.props.primary.lighter,
    fontSize: 14,
  },
  actions: {
    marginTop: theme.spacing(3),
    paddingTop: theme.spacing(2),
    borderTop: `1px solid ${theme.props.border}`,
  },
  actionButtons: {
    gap: theme.spacing(1.5),
    flexWrap: "wrap",
  },
}));

export default useStyle;
